import {Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ReportADAExtraParams} from '../../models/ReportADAExtraParamsModel.model';
import {UntypedFormControl} from '@angular/forms';
import { AdditionalInfo } from 'src/app/models/accountsReceivable/data-ar-claim.model';


@Component({
  selector: 'app-report-ada-parameters',
  templateUrl: './report-ada-parameters.component.html',
  styleUrls: ['./report-ada-parameters.component.scss']
})
export class ReportAdaParametersComponent implements OnInit {

  diagCodeListQualifierA: string;
  diagCodeListQualifierB: string;
  diagCodePrimA: string;
  diagCodePrimB: string;
  diagCodePrimC: string;
  diagCodePrimD: string;
  remarks: string;
  reportADAParams: AdditionalInfo;
  doctor = new UntypedFormControl();


  constructor(public dialogRef: MatDialogRef<ReportAdaParametersComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {


    this.reportADAParams = new AdditionalInfo();
  }

  ngOnInit(): void {
    const reportADAExtraParams = JSON.parse(JSON.stringify(this.data.AdditionalInfo));
    if (reportADAExtraParams !== undefined) {
      this.reportADAParams = {
        dxcClaimId: reportADAExtraParams.dxcClaimId,
        dxcAttachmentId: reportADAExtraParams.dxcAttachmentId,
        ADAParameters: reportADAExtraParams.ADAParameters
      };
    }
  }

  closeRef(){
    this.dialogRef.close(null);
  }
    SaveClaimStatus(){
      this.dialogRef.close(this.reportADAParams);
    }


}
